import { CommonModule } from '@angular/common';
import { Component, DestroyRef, Inject, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GENERIC_AUTH_SERVICE_TOKEN, GenericAuthService } from '@nk/auth-lib';
import { AppUserAccountEntity, Auth0UserVerified } from '@nk/data-entities-lib';
import { ButtonDirective, CardComponent, CardContentComponent } from '@nk/ui-lib';
import { interval } from 'rxjs';
import { mergeMap, takeWhile } from 'rxjs/operators';
import { SignUpService } from '../../../../services/sign-up.service';

@Component({
  selector: 'nk-sign-up-success',
  imports: [CommonModule, TranslateModule, CardComponent, CardContentComponent, ButtonDirective],
  templateUrl: './sign-up-success.component.html',
  styleUrls: ['./sign-up-success.component.scss'],
})
export class SignUpSuccessComponent implements OnInit {
  public signedUpUserAccount: AppUserAccountEntity;
  public auth0User: Auth0UserVerified;
  private _destroy = inject(DestroyRef);

  constructor(
    private _signUpService: SignUpService,
    private _router: Router,
    @Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService,
  ) {}

  public ngOnInit(): void {
    this.signedUpUserAccount = this._signUpService.signedUpUserAccount;

    if (this.signedUpUserAccount) {
      const source = interval(2000);

      // Public (pre-login) poll for email-verification status. Returns only the
      // email_verified boolean — no PII.
      const userAccountVerifiedObs$ = this._signUpService.getAuth0UserFromAppUserAccount(
        this._signUpService.signedUpUserAccount.uuid,
      );

      // Each 2. second until email is verified we will check if email is verified. Then try to login or redirect to /login

      source
        .pipe(
          mergeMap(() => userAccountVerifiedObs$),
          takeWhile((payload) => {
            this.auth0User = payload;
            if (this.auth0User.email_verified) {
              this.tryAutomaticallyLoginUser();
            }
            return !payload.email_verified;
          }),
          takeUntilDestroyed(this._destroy),
        )
        .subscribe();
    }
  }

  public tryAutomaticallyLoginUser(): void {
    if (this.signedUpUserAccount && this.signedUpUserAccount.email && this._signUpService.formUser.value.password) {
      this._authService.login(this.signedUpUserAccount.email, this._signUpService.formUser.value.password, () => {
        console.error('Could not automatically log user in. Redirect them to login screen');

        this._signUpService.formUser = null;
        void this._router.navigate(['/login']);
      });
    } else {
      void this._router.navigate(['/login']);
    }
  }
}
